import React, { Component } from 'react';

import { StyledTextWrapper } from './styles/StyledTextWrapper';


class TextWrapper extends Component {
  render() {
    const { children } = this.props;
    return (
      <StyledTextWrapper>
        {children}
      </StyledTextWrapper>
    );
  }
}

export default TextWrapper;
